export default "__VITE_ASSET__CmxXTbxE__"